import { Inject, Injectable } from '@angular/core';
import {UserSearchRequest} from '../model/user-search-request.model';
import { AllUsersSearchRequest } from '../model/all-users-search-request.model';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UserDirectoryApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getSearchCriteria(portalId: number) {
        return this.http.get(this.baseUri + '/UserDirectory/GetSearchCriteria/' + portalId.toString());
    }

    search(userSearchRequest: UserSearchRequest) {
        return this.http.post(this.baseUri + '/UserDirectory/Search', userSearchRequest);
    }

    getAllUsers(searchType:number, data: AllUsersSearchRequest) {
        return this.http.post(this.baseUri + '/UserDirectory/All/'+searchType, data);
    }
}